var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#C0C6CB",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2138 16.2346L7.74736 14.2333L4.16841 23.7142L4.66406 24.0004L11.2138 16.2346ZM3 10.273L4.27777 8.09172L6.56555 8.38524C7.4475 8.42722 8.04793 8.18027 8.76866 7.24928L11.0938 4.24606C11.4025 3.84707 11.7684 3.57472 11.1506 2.6896L10.4391 1.66936L11.4166 0C14.8548 1.98474 18.2927 3.96984 21.7309 5.95458L20.7738 7.63628L19.5345 7.5301C18.4588 7.43767 18.4059 7.89064 18.2147 8.35737L16.7764 11.8728C16.3302 12.9626 16.4169 13.6057 16.8943 14.349L18.2923 16.1834L17.0421 18.3806L3 10.273Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPin);
export default __webpack_public_path__ + "static/media/icon_pin.9b931c199d71733f815761bc29772a9b.svg";
export { ForwardRef as ReactComponent };